module.exports = __webpack_public_path__ + "media/init/static/fonts/GT-Eesti-Pro-Display-Thin-431f2457d76404b5e270ad3ef72ead1c.OTF";